module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "title-page"
  }, [_vm._v(_vm._s(_vm.tituloDaPagina))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26100638"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CabecalhoDoConteudo.vue
// module id = 1097
// module chunks = 1